import { Flex, Popover, Text } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { useEffect, useState } from "react";

import { RoundIconButton, WeekPicker } from "~/components";
import SvgIconRaw from "~/components/SvgIconRaw";
import { useSemanticColors } from "~/utils/Theme/useSemanticColors";
import { DateFormat } from "~/utils/Types";
import dayjs, { Dayjs } from "~/utils/dayjs";

export const DateFormatWeekOnly = "[Week] w, YYYY";

const WeekSelect = ({
  defaultValue,
  onChange,
}: {
  defaultValue?: Dayjs;
  onChange: (value: Dayjs) => void;
}) => {
  const [firstDayOfCurrentWeek, setFirstDayOfCurrentWeek] = useState<Dayjs>(
    defaultValue || dayjs().startOf("isoWeek"),
  );
  useEffect(() => {
    setFirstDayOfCurrentWeek(defaultValue || dayjs().startOf("isoWeek"));
  }, [defaultValue]);
  const [opened, setOpened] = useState(false);

  const colors = useSemanticColors();
  const isSmallScreen = useMediaQuery("(max-width: 60em)", false, {
    getInitialValueInEffect: false,
  });

  const dateFormat = "ddd " + DateFormat.DAY_AND_MONTH;

  return (
    <Popover
      opened={opened}
      onChange={setOpened}
      position="bottom-end"
      shadow="md"
    >
      <Popover.Target>
        <Flex
          direction="row"
          gap={16}
          justify="space-between"
          align="center"
          onClick={() => setOpened((o) => !o)}
          p={16}
          h={48}
          style={{
            border: `1px solid ${colors.mybuttonborder.secondary}`,
            borderRadius: 12,
          }}
        >
          <Text size={isSmallScreen ? "xs" : "sm"} fw={600}>
            {`${firstDayOfCurrentWeek.format(DateFormatWeekOnly)} (${firstDayOfCurrentWeek.format(dateFormat)} - ${firstDayOfCurrentWeek
              .endOf("isoWeek")
              .format(dateFormat)})`}
          </Text>
          <RoundIconButton>
            <SvgIconRaw name="Calendar" size={24} />
          </RoundIconButton>
        </Flex>
      </Popover.Target>
      <Popover.Dropdown>
        <Flex direction="column" m={16}>
          <WeekPicker
            defaultValue={firstDayOfCurrentWeek}
            onCancel={() => setOpened(false)}
            onConfirm={(v) => {
              const weekStart = v.startOf("isoWeek");
              setFirstDayOfCurrentWeek(weekStart);
              onChange(weekStart);
              setOpened(false);
            }}
          />
        </Flex>
      </Popover.Dropdown>
    </Popover>
  );
};

export default WeekSelect;
